const operationPackageConfigEn = {
  assignment: {
    addPerson: 'Add person',
    back: 'Back',
    cancel: 'Cancel',
    designationModeDescription: 'Configure how approver designation is handled at submit time.',
    designationModeHelp: {
      none: 'No approver designation is required at submit time.',
      optional: 'You can optionally designate approvers before submitting.',
      required: 'Approver designation is required before submission.'
    },
    designationModeLabel: 'Designation mode',
    designationModeOption: {
      none: 'No designation',
      optional: 'Optional designation',
      required: 'Required designation'
    },
    designationModePlaceholder: 'Select designation mode',
    eligibleAssignee: 'Eligible assignee',
    loading: 'Loading...',
    option: {
      operator: 'Operator',
      peopleGroup: 'People group',
      person: 'Person',
      target: 'Target'
    },
    parallelTasks: 'Parallel Tasks',
    select: 'Select',
    selectPeopleGroupPrompt: 'Please select a people group.',
    selectPersonPrompt: 'Select a person from the dropdown.',
    success: 'Assignee settings updated',
    unconfigured: 'Not configured'
  },
  attribute: {
    status: {
      readonly: 'readonly'
    },
    usage: {
      allNotUsedDisabled: 'At least one item must be used',
      definition: 'definition',
      itemName: 'name',
      notUsed: 'Not needed',
      readOnly: 'This item is read-only and cannot be edited',
      systemRequired: 'System required',
      usage: 'usage'
    }
  },
  createPatternDialog: {
    description: 'Enter pattern name and description',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Enter the purpose or features of the pattern',
    nameLabel: 'Pattern Name',
    namePlaceholder: 'e.g., New Hire Pattern',
    title: 'Create New Pattern'
  },
  error: {
    cannotDisableApprovalTask: 'Approval tasks cannot be disabled',
    cannotDisableSystemRequiredTask: 'Tasks containing system required items cannot be disabled',
    disableFailed: 'Disable failed',
    enableFailed: 'Enable failed'
  },
  notUsed: {
    tasks: 'Unused tasks',
    title: 'Not used'
  },
  packagePatternDetail: {
    configure: 'Configure',
    configuring: 'Configuring'
  },
  patternDraftBadge: 'Draft',
  success: {
    enableTaskDescription: "Task '{{name}}' has been enabled",
    taskDisabled: "Task '{{name}}' has been disabled"
  }
};
export default operationPackageConfigEn;